/**
 * The gap between the grid lines in pixels.
 *
 * Used for calculating diffs when moving elements.
 */
export const gap = 4;
